import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import {Link} from 'react-router-dom';

//import img
import fieldRed from '../../assets/icons/field-red.svg';
import fieldGreen from '../../assets/icons/field-green.svg';
import fieldYellow from '../../assets/icons/field-yellow.svg';
import fieldViolet from '../../assets/icons/field-violet.svg';

import HeadingsTitleSearchResultsDetail from './HeadingsTitleSearchResultsDetail.js';

const HeadingsTitleSearchResultsItem = ({ clang, domainCode, headings, reduceByAdding, searchKey}) => {
    const getImgField = (label) => {
        switch (label) {
            case 'literature-theory':
                return <img src={fieldViolet} alt="" />;
            case 'polish-literature':
                return <img src={fieldRed} alt="" />;
            case 'foreign-literature':
                return <img src={fieldYellow} alt="" />;
            case 'movie-theatre-rtv':
                return <img src={fieldGreen} alt="" />;
            default:
                return;
        }
    };

    const getSeparatorColor = (label) => {
        switch (label) {
            case 'literature-theory':
                return <div className="headings-results__list-item--separator"></div>;
            case 'polish-literature':
                return <div className="headings-results__list-item--separator red"></div>;
            case 'foreign-literature':
                return <div className="headings-results__list-item--separator yellow"></div>;
            case 'movie-theatre-rtv':
                return <div className="headings-results__list-item--separator green"></div>;
            default:
                return;
      }
    }

    const getItemCount = () => {
        if (!headings || headings.length < 1) {
            return;
        }

        return reduceByAdding(headings.map(resultHeading => resultHeading.recordsNumber));
    };

    return (
        <li className="headings-results__list-item">
            <h5 className="headings-results__list-item--title">
                {getImgField(domainCode)}
                <span className="headings-results__list-item--title-field">{lang[clang].characteristics.heading}:</span>
                <div className="headings-results__list-item--title-type">
                    <strong> {lang[clang].characteristics[domainCode]} </strong>
                    <span className="headings-results__list-item--count">({getItemCount()})</span>
                </div>
            </h5>
            {getSeparatorColor(domainCode)}
            <ul className="headings-results__list--inner">
                {headings.map((heading, index) =>
                    <HeadingsTitleSearchResultsDetail key={index} searchKey={searchKey} {...heading}/>)}
            </ul>
            <Link to={'/#'} className="headings-results__list--inner__btn-all">
                {lang[clang].characteristics.show_all_from_field}
                <span className="headings-results__list--inner__btn-all--img"></span>
            </Link>
            <div className="clearfix"></div>
        </li>
    );
};

HeadingsTitleSearchResultsItem.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(HeadingsTitleSearchResultsItem);



// WEBPACK FOOTER //
// ./src/components/characteristics/HeadingsTitleSearchResultsItem.js